import {
    OBSERVATION_OUTCOMES,
    MFR_RECEIVES,
    MFR_DOES_NOT_RECEIVE,
    OUTCOMES,
    FINAL_MESSAGE,
} from "./data";
import { StatusChip, Kicker, LocalBoundary } from "./ui";

export const ActService = () => (
    <section data-testid="act-service" className="space-y-10">
        <div>
            <Kicker>Act 5 — Observation and feedback</Kicker>
            <h2 className="mt-2 text-2xl font-medium tracking-tight text-slate-900">
                A bounded observation period closes the loop
            </h2>
            <div className="mt-3">
                <StatusChip tone="green" testId="service-final-state">
                    PILOT VERIFIED — CONTROLLED SCALE AVAILABLE
                </StatusChip>
            </div>

            <div className="mt-6 grid gap-4 lg:grid-cols-2">
                <div className="rounded-sm border border-slate-200 bg-white p-6" data-testid="observation-card">
                    <p className="text-xs font-medium uppercase tracking-wide text-slate-400">
                        Synthetic post-release outcomes
                    </p>
                    <ul className="mt-3 space-y-1 text-sm text-slate-700">
                        {OBSERVATION_OUTCOMES.map((o) => <li key={o}>· {o}</li>)}
                    </ul>
                </div>

                <LocalBoundary testId="feedback-panel">
                    <p className="text-sm font-medium text-slate-900">
                        Bounded feedback receipts return to the manufacturer
                    </p>
                    <div className="mt-3 grid gap-4 sm:grid-cols-2">
                        <div>
                            <p className="font-mono text-[10px] uppercase tracking-wide text-green-700">
                                The manufacturer receives
                            </p>
                            <ul className="mt-1 space-y-0.5 text-sm text-slate-600">
                                {MFR_RECEIVES.map((m) => <li key={m}>· {m}</li>)}
                            </ul>
                        </div>
                        <div>
                            <p className="font-mono text-[10px] uppercase tracking-wide text-red-700">
                                The manufacturer does not receive
                            </p>
                            <ul className="mt-1 space-y-0.5 text-sm text-slate-600">
                                {MFR_DOES_NOT_RECEIVE.map((m) => <li key={m}>· {m}</li>)}
                            </ul>
                        </div>
                    </div>
                </LocalBoundary>
            </div>

            <p
                className="mt-6 border-l-2 border-blue-950 pl-4 text-sm font-medium leading-relaxed text-slate-900"
                data-testid="service-final-message"
            >
                {FINAL_MESSAGE}
            </p>
        </div>

        <div>
            <Kicker>Alternative outcomes</Kicker>
            <h3 className="mt-2 text-xl font-medium tracking-tight text-slate-900">
                Five distinguishable end-states — more than a happy path
            </h3>
            <div className="mt-4 grid gap-4 md:grid-cols-2 xl:grid-cols-3" data-testid="outcomes-glossary">
                {OUTCOMES.map((o) => (
                    <div key={o.state} className="rounded-sm border border-slate-200 bg-white p-5" data-testid={`outcome-${o.state.toLowerCase().replace(/\s/g, "-")}`}>
                        <StatusChip tone={o.tone}>{o.state}</StatusChip>
                        <p className="mt-2 font-mono text-[11px] text-slate-500">{o.example}</p>
                        <p className="mt-2 text-sm leading-relaxed text-slate-600">{o.desc}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);
